
import Markdown from 'utils/markdown'
import HtmlMapper from './html-mapper.vue'

export default {
  components: {HtmlMapper},
  props: {
    markdown: {type: String, required: true},
    restricted: {type: Boolean, default: false}
  },
  data() {
    return {
      parser: new Markdown()
    }
  },
  computed:{
    nodes() {
      const div = document.createElement('div')
      div.innerHTML = this.parser.makeHTML(this.markdown)
      return div.childNodes
    }
  }
}
